import {
  AuthorizationSettings,
  initializePricingHttp,
  initializeProductCatalogueHttp,
  initializeSiteSettingsHttp,
  initializeStoreApiHttp,
  setMavenoidApiConfig,
  SfccSettings,
  SiteContext as JSSContext,
  SiteContext,
} from '@gn-audio/jss-core';

import { PublicEnvironmentConfigs } from 'common/types/commonTypes';

export const SITE_CONTEXT: SiteContext = 'jabra' as SiteContext;

export const configurePricingApi = (
  sfccSettings: SfccSettings,
  isSFCCPricingOn: boolean,
  language: string
) => {
  initializePricingHttp({
    baseUrl: sfccSettings.shopApiBaseUrl ?? '',
    marketLocale: language,
    isSFCCPricingOn: isSFCCPricingOn,
    shopApiClientId: sfccSettings.shopApiClientId ?? '',
  });
};

export const configureMavenoidApi = (authSettings: AuthorizationSettings) => {
  setMavenoidApiConfig({
    scopes: authSettings?.mavenoidAPIScopes ?? [],
  });
};

export const initializeHttpClients = (envConfig: PublicEnvironmentConfigs) => {
  const { siteSettingsApiBaseUrl, productCatalogueBaseUrl, productCatalogueApiKey } =
    envConfig || {};

  if (siteSettingsApiBaseUrl) {
    initializeSiteSettingsHttp({
      siteContext: JSSContext.Jabra,
      baseUrl: siteSettingsApiBaseUrl,
    });
  }

  if (productCatalogueBaseUrl) {
    initializeProductCatalogueHttp({
      baseUrl: productCatalogueBaseUrl,
      apiKey: productCatalogueApiKey,
    });
  }

  initializeStoreApiHttp({ baseUrl: '' });
};
